import React, { useState } from "react";

import Button from "../Button";
import Modal from "../Modal";

const inputStyle: React.CSSProperties = {
  width: "100%",
  fontFamily: "var(--font-sans)",
  fontSize: 14,
  color: "var(--ink-900)",
  background: "#fff",
  border: "1px solid var(--border-strong)",
  borderRadius: 8,
  padding: "11px 13px",
  outline: "none",
};

/** Suspend / disable a user — required, audited reason + danger confirm. */
export default function AccountModal({
  verb,
  userName,
  onCancel,
  onConfirm,
}: {
  verb: "suspend" | "disable";
  userName: string;
  onCancel: () => void;
  onConfirm: (reason: string) => Promise<void>;
}) {
  const [reason, setReason] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    if (!reason.trim()) {
      setErr("A reason is required.");
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      await onConfirm(reason.trim());
    } catch (e: any) {
      setErr(e?.message || "Action failed");
      setBusy(false);
    }
  };

  const title = verb === "suspend" ? "Suspend user" : "Disable user";
  const intro =
    verb === "suspend"
      ? `Suspend ${userName}. They will be signed out and blocked until unsuspended.`
      : `Disable ${userName}. This is a soft-delete; the account can be restored.`;

  return (
    <Modal title={title} onClose={onCancel}>
      <p style={{ margin: "0 0 16px", fontSize: 13.5, color: "var(--text-body)", lineHeight: 1.55 }}>{intro}</p>
      <label style={{ display: "block", fontFamily: "var(--font-sans)", fontWeight: 600, fontSize: 12.5, color: "var(--ink-700)", marginBottom: 6 }}>
        Reason <span style={{ color: "var(--danger-500)" }}>(required, audited)</span>
      </label>
      <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Abuse report #221" style={inputStyle} autoFocus />
      {err && <p style={{ margin: "6px 0 0", color: "var(--danger-500)", fontSize: 12.5 }}>{err}</p>}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
        <Button variant="ghost" onClick={onCancel}>Cancel</Button>
        <button
          type="button"
          onClick={confirm}
          disabled={busy}
          style={{ display: "inline-flex", alignItems: "center", fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 14, color: "#fff", background: "var(--danger-500)", border: "none", borderRadius: 10, padding: "11px 20px", cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.6 : 1 }}
        >
          {busy ? "Working…" : title}
        </button>
      </div>
    </Modal>
  );
}
